/**
 * SpeedIndicator Component
 *
 * Displays the current playback speed when it's not 1x.
 * Shows as a small overlay badge with the speed multiplier (2x, 3x, 4x).
 */

import { CSSProperties } from 'react';
import { usePlaybackSpeed } from '@/stores/playbackStore';

function SpeedIndicator() {
  const playbackSpeed = usePlaybackSpeed();

  // Don't show anything at normal speed
  if (playbackSpeed === 1) {
    return null;
  }

  const containerStyles: CSSProperties = {
    position: 'fixed',
    bottom: '180px', // Above timeline
    right: '20px',
    zIndex: 1000,
    pointerEvents: 'none', // Don't block clicks
    animation: 'fadeIn 0.15s ease-in',
  };

  const badgeStyles: CSSProperties = {
    backgroundColor: 'var(--nb-accent-primary)',
    color: 'white',
    padding: '8px 16px',
    borderRadius: 'var(--nb-radius-md)',
    fontSize: 'var(--nb-font-size-lg)',
    fontWeight: 700,
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.4)',
    border: '2px solid rgba(255, 255, 255, 0.2)',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  };

  const speedTextStyles: CSSProperties = {
    fontSize: '24px',
    lineHeight: 1,
  };

  const labelStyles: CSSProperties = {
    fontSize: 'var(--nb-font-size-xs)',
    opacity: 0.9,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  };

  return (
    <div style={containerStyles}>
      <div style={badgeStyles}>
        <span style={speedTextStyles}>{playbackSpeed}×</span>
        <span style={labelStyles}>Speed</span>
      </div>
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}

export default SpeedIndicator;
